module.exports = __webpack_public_path__ + "static/img/combinedValveImg.70f9309.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/combinedValveImg.png
// module id = ZHh8
// module chunks = 1